module.exports = __webpack_public_path__ + "static/media/this way again_-01.5aa4f2b3.png";